export function getPreparedDate (stringDate: string | undefined, prefix: string = '') {
  if (!stringDate) {
    return undefined;
  }

  const date = new Date(stringDate);

  return `${ prefix }${ date.toLocaleDateString('ru-RU') }`;
}
